import { AxiosError } from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  CreateIpListRequest,
  CreateIpListResponse,
  DeleteIpItemResponse,
  GetIpListResponse,
  UpdateIpListItemRequest,
  UpdateIpListItemResponse,
} from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { createIpListItem, deleteIpItem, getIpList, updateIpListItem } from './api';

export const IP_LIST_QUERY_KEY = ['system-security', 'ip-list'];

export const useGetIpList = (enabled: boolean) =>
  useQuery<GetIpListResponse, AxiosError>({
    queryKey: IP_LIST_QUERY_KEY,
    queryFn: getIpList,
    enabled,
  });

export const useUpdateIpListItem = () => {
  const queryClient = useQueryClient();
  return useMutation<UpdateIpListItemResponse, AxiosError, UpdateIpListItemRequest>({
    mutationFn: updateIpListItem,
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: IP_LIST_QUERY_KEY });
    },
  });
};

export const useCreateIpListItem = () => {
  const queryClient = useQueryClient();
  return useMutation<CreateIpListResponse, AxiosError, CreateIpListRequest>({
    mutationFn: createIpListItem,
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: IP_LIST_QUERY_KEY });
    },
  });
};

export const useDeleteIpItem = () => {
  const queryClient = useQueryClient();
  return useMutation<DeleteIpItemResponse, AxiosError, string>({
    mutationFn: deleteIpItem,
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: IP_LIST_QUERY_KEY });
    },
  });
};
